var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.renderAsRow ? 'wc-row' : '', 'img-element']},[_c('div',{class:[_vm.renderAsRow ? 'wc-col' : '', 'img-element__inner']},[(_vm.breakpoints && _vm.breakpoints.length > 0)?_c('img',{attrs:{"srcset":`${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_xs.png ${_vm.breakpoints[0]}w,
            ${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_sm.png ${_vm.breakpoints[1]}w,
            ${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_md.png ${_vm.breakpoints[2]}w,
            ${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_lg.png ${_vm.breakpoints[3]}w,
            ${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_xl.png ${_vm.breakpoints[4]}w`,"src":`${_vm.assetsBaseUrl}/${_vm.imagePath}/${_vm.imageName}_xl.png`,"sizes":`
            (min-width: 1362px) ${_vm.breakpoints[4]}px,
            (min-width: 1024px) ${_vm.breakpoints[3]}px, 
            (min-width: 800px) ${_vm.breakpoints[2]}px,
            (min-width: 600px) ${_vm.breakpoints[1]}px,
            (max-width: 427px) ${_vm.breakpoints[0]}px,
            ${_vm.breakpoints[0]}px
          `,"alt":""}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }